import React, { useState, useEffect } from "react";
import Loginimg from "../components/img/Login.svg";
import { useLocation } from "react-router-dom";
import api from "../api/axiosInstance";
import { useNavigate } from "react-router-dom"; // Import useNavigate hook

const Otp = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const location = useLocation();
  const navigate = useNavigate(); // Initialize the navigate function
  const phoneNumber = location.state?.phoneNumber;
  const countryCode = location.state?.countrycode;
  const email = location.state?.email;

  console.log(phoneNumber);
  console.log(countryCode);

  const { from, project_type, id } = location.state || {};
  const returnPath = from?.pathname || "/dashboard";
  console.log("nnnn", project_type, id);

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isResending, setIsResending] = useState(false);
  const [resendCountdown, setResendCountdown] = useState(0);

  const handleChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;
    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    // Auto-focus next input
    if (value && index < 5) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const handleSubmit = async () => {
    const finalOtp = otp.join("");
    if (finalOtp.length !== 6) {
      showModal("Please enter the full 6-digit code");
      return;
    }

    // Determine which value to use (phone or email)
    const loginValue = email || phoneNumber;

    // Ensure that either phone number or email is provided
    if (!loginValue) {
      showModal("Phone number or email is required.");
      return;
    }

    try {
      console.log("Submitting login with value: ", loginValue); // Debugging log
      // Send OTP for login using either phone number or email
      const response = await api.post("/api/login/", {
        phone_number: loginValue, // Make sure to pass phone_number or email
        otp: finalOtp,
      });

      if (response.status === 200 && response.data.status === "success") {
        const { access, refresh, user_id } = response.data.data;
        const userType = response.data.user_type;

        if (userType === "existing_user") {
          localStorage.setItem("accessToken", access);
          localStorage.setItem("refreshToken", refresh);
          localStorage.setItem("user_id", user_id);
          navigate(returnPath, { state: { project_type, id } }); // Navigate to the previous path or default to /dashboard
        } else {
          navigate("/signup", {
            state: {
              type:
                userType === "existing_user" ? null : email ? "email" : "phone",
              value: loginValue,
            },
          });
        }
      } else {
        showModal(response.data.message || "Login failed.");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      alert("Verification failed. Please try again.");
    }
  };

  const showModal = (message) => {
    setModalMessage(message);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalMessage("");
    setOtp(["", "", "", "", "", ""]);
  };

  const handleSendOtp = async () => {
    if (resendCountdown > 0 || isResending) return;

    setIsResending(true);

    try {
      const payload = email
        ? {
            phone_number: email, // using email as phone_number for email login
            country_code: countryCode, // empty for email
          }
        : {
            phone_number: phoneNumber,
            country_code: countryCode,
          };

      const response = await api.post("api/v1/get-otp-for-login", payload);

      if (
        response.data.status === "success" &&
        response.data.response_code === 201
      ) {
        setResendCountdown(30); // Start countdown
      } else {
        alert("Failed to send OTP");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsResending(false);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();

      const newOtp = [...otp];

      if (newOtp[index]) {
        // If current input has a value, clear it
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        // Move to previous input and clear it
        const prevInput = document.getElementById(`otp-input-${index - 1}`);
        if (prevInput) {
          prevInput.focus();
          newOtp[index - 1] = "";
          setOtp(newOtp);
        }
      }
    } else if (e.key.match(/^[0-9]$/)) {
      // Optional: allow only digits
      // You can also handle paste events similarly
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("Text").trim();

    if (!/^\d+$/.test(pastedData)) {
      // If pasted content is not digits, ignore
      return;
    }

    const pastedDigits = pastedData.slice(0, 6).split("");

    const newOtp = [...otp];
    for (let i = 0; i < pastedDigits.length; i++) {
      newOtp[i] = pastedDigits[i];
    }

    setOtp(newOtp);

    // Focus the input after the last pasted digit (if any)
    const nextIndex = pastedDigits.length < 6 ? pastedDigits.length : 5;
    const nextInput = document.getElementById(`otp-input-${nextIndex}`);
    if (nextInput) nextInput.focus();
  };

  useEffect(() => {
    let timer;
    if (resendCountdown > 0) {
      timer = setTimeout(() => {
        setResendCountdown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [resendCountdown]);

  return (
    <div className="min-h-screen flex flex-col lg:flex-row">
      {/* Left Content */}
      <div className="w-full lg:w-1/2 flex justify-center items-center mt-10 sm:mt-14 md:mt-20 lg:mt-16 xl:mt-20 px-6">
        <div className="w-full max-w-md">
          <h2 className="text-2xl font-bold text-center text-black mb-2 font-inter">
            {email && <span>Email</span>} {phoneNumber && <span>Mobile</span>}{" "}
            Verification
          </h2>
          <p className="text-center mb-6 font-inter text-sm text-black">
            We’ll send a 6-digit verification
            <br />
            code to {phoneNumber} {email} {""}
            confirm your identity.
          </p>

          {/* OTP Input */}
          <div className="flex justify-center items-center sm:gap-6 gap-3 mt-8 font-semibold">
            {[...Array(6)].map((_, index) => (
              <input
                key={index}
                id={`otp-input-${index}`}
                type="text"
                pattern="\d*"
                inputMode="numeric"
                maxLength="1"
                value={otp[index]}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                onPaste={handlePaste}
                className="w-12 h-12 text-center border-2 rounded-xl outline-none font-inter text-lg"
                style={{
                  borderColor: "#9061DB",
                  backgroundColor: "#fff",
                }}
              />
            ))}
          </div>

          {/* Login Button */}
          <div className="flex justify-center mt-8">
            <button
              type="submit"
              onClick={handleSubmit}
              className="bg-gradient-to-r from-[#4C3A68] to-[#9061DB] text-white rounded-md hover:opacity-90 transition font-inter w-32 py-2 mb-5"
            >
              Login Now
            </button>
          </div>

          {/* Resend Code Link */}
          <div className="font-inter flex justify-center items-center mt-8 text-sm">
            Didn’t get the OTP?
            {resendCountdown > 0 ? (
              <span className="ml-1 text-gray-500 font-medium">
                Resend in {resendCountdown}s
              </span>
            ) : (
              <span
                className="ml-1 font-semibold"
                style={{
                  color: "#9367D7",
                  cursor: isResending ? "default" : "pointer",
                }}
                onClick={handleSendOtp}
              >
                {isResending ? "Resending..." : "Resend it."}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Right Content: Background Image */}
      <div
        className="w-full lg:w-1/2 min-h-[300px] lg:min-h-screen bg-no-repeat bg-center bg-cover"
        style={{ backgroundImage: `url(${Loginimg})` }}
      ></div>

      {/* Modal */}
      {modalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-md max-w-sm w-full shadow-lg text-center">
            <p className="text-gray-800 mb-4">{modalMessage}</p>
            <button
              onClick={closeModal}
              className="px-4 py-2 bg-[#9061DB] text-white rounded hover:opacity-90"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Otp;
